"use strict";
/**
 * 期权提示框
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.openModal = exports.modal = void 0;
var cookie_1 = __importDefault(require("../cookie"));
var closeimg_1 = require("./closeimg");
var is_mobile = false; //是不是手机
var never = false; //不再提示
var islogin = cookie_1["default"].get('ut') != null;
var quotedelaytip_is_option = false; //是否是期权
if (window['quotedelaytip_is_option'] != undefined) {
    quotedelaytip_is_option = window['quotedelaytip_is_option'];
}
if (cookie_1["default"].get('quotedelaytip_never') == '1') {
    never = true;
}
if (navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('mobile') > -1) {
    is_mobile = true;
}
function modal() {
    Open();
}
exports.modal = modal;
var mask_html = "";
var reg_btn = "<a href=\"https://passport2.eastmoney.com/pub/reg?backurl=".concat(encodeURIComponent(self.location.href), "\" class=\"quotedelaytip_btn_w\">5\u79D2\u6CE8\u518C</a>");
if (is_mobile) {
    reg_btn = "<a href=\"http://mpassport.eastmoney.com/regforphone?backurl=".concat(encodeURIComponent(self.location.href), "\" class=\"quotedelaytip_btn_w\">5\u79D2\u6CE8\u518C</a>");
}
var log_btn = "<a href=\"https://passport2.eastmoney.com/pub/login?backurl=".concat(encodeURIComponent(self.location.href), "\" class=\"quotedelaytip_btn_r\">\u767B\u5F55</a>");
if (is_mobile) {
    log_btn = "<a href=\"https://mpassport.eastmoney.com/login?backurl=".concat(encodeURIComponent(self.location.href), "\" class=\"quotedelaytip_btn_r\">\u767B\u5F55</a>");
}
var change_btn = "<a href=\"https://passport2.eastmoney.com/pub/passsafe\" class=\"quotedelaytip_btn_r\">\u6362\u7ED1\u624B\u673A\u53F7</a>";
if (is_mobile) {
    change_btn = "<a href=\"https://emwap.eastmoney.com/goapp/nlink.html?type=localurl&curl=xxlout_dfcfappdfcfWAP_random_0005786a&&wxcurl=xxlout_dfcfappdfcfWAP_random_0005786a&id=eastmoney%3A%2F%2Fwireless%2Fh5%2Ftrade%3Furl%3Dhttps%3A%2F%2Fmaccount2.eastmoney.com%2Fmobile%2Fbind%2Fchangemobile&a_id=dfcft%3A%2F%2Fquicktrade%3Ftradeflag%3Dwebh5%26url%3Dhttps%3A%2F%2Fmaccount2.eastmoney.com%2Fmobile%2Fbind%2Fchangemobile\" class=\"quotedelaytip_btn_r2\">\u6253\u5F00APP\u6362\u7ED1\u624B\u673A\u53F7</a>";
}
var closebtn = document.createElement('div');
closebtn.className = 'quotedelaytip_close';
if (is_mobile) {
    closebtn.innerHTML = "<img src=\"".concat(closeimg_1.close_img, "\" style=\"width:22px; height:22px;\" />");
}
else {
    closebtn.innerText = 'X';
}
closebtn.onclick = function () {
    Close();
};
var neverbtn = document.createElement('div');
neverbtn.className = 'quotedelaytip_never';
neverbtn.innerHTML = "<label><input type=\"checkbox\" id=\"quotedelaytip_never_input\" ".concat(never ? 'checked' : '', " />\u4E0D\u518D\u63D0\u793A</label>");
var tiptext = '由于交易所监管要求，海外用户查看沪深京市场行情延迟15分钟。可以通过登录<strong style="font-weight:bold;">中国大陆手机号</strong>查看实时行情。';
if (islogin) {
    tiptext = '由于交易所监管要求，海外用户查看沪深京市场行情延迟15分钟。绑定<strong style="font-weight:bold;">中国大陆手机号</strong>查看实时行情。';
}
if (true) {
    tiptext = '由于交易所监管要求，海外用户暂不支持查看上交所、深交所期权行情。可以通过登录<strong style="font-weight:bold;">中国大陆手机号</strong>获取上交所、深交所期权行情。';
    if (islogin) {
        tiptext = '由于交易所监管要求，海外用户暂不支持查看上交所、深交所期权行情。可以通过绑定<strong style="font-weight:bold;">中国大陆手机号</strong>获取上交所、深交所期权行情。';
    }
}
var html = "\n<div id=\"quotedelaytip\" class=\"".concat(is_mobile ? 'quotedelaytip_mobile' : '', "\">\n  <div id=\"quotedelaytip_mask\"></div>\n  <div id=\"quotedelaytip_body\">\n    <div class=\"quotedelaytip_title\">\u6E29\u99A8\u63D0\u793A</div>\n    <div id=\"quotedelaytip_never\"></div>\n    <div id=\"quotedelaytip_close\"></div>\n    <div class=\"quotedelaytip_txt\">").concat(tiptext, "</div>\n    <div class=\"quotedelaytip_btn\">\n      ").concat(islogin ? '' : reg_btn, " ").concat(islogin ? '' : log_btn, "\n      ").concat(islogin ? change_btn : '', "\n    </div>  \n  </div>\n</div>\n");
//
var div = document.createElement('div');
function Open() {
    // //每天一次
    // if(!quotedelaytip_is_option){
    //   let thisdate = ((new Date()).getMonth() + 1) + '-' + ((new Date()).getDate())
    //   let quotedelaytip_date = cookie.get('quotedelaytip_date')
    //   if(quotedelaytip_date == thisdate) {
    //     return false
    //   }
    //   else{
    //     cookie.set('quotedelaytip_date', thisdate, 2, '.eastmoney.com')
    //   }    
    // }
    openModal();
}
function openModal() {
    var _a;
    var body = document.body;
    div.innerHTML = mask_html + html;
    body.appendChild(div);
    (_a = document.getElementById('quotedelaytip_close')) === null || _a === void 0 ? void 0 : _a.appendChild(closebtn);
    // if(!quotedelaytip_is_option){
    //   document.getElementById('quotedelaytip_never')?.appendChild(neverbtn)
    // }
    // //不再提示
    // let quotedelaytip_never_input = document.getElementById('quotedelaytip_never_input') as HTMLInputElement
    // if(quotedelaytip_never_input){
    //   quotedelaytip_never_input.onclick = function(e){
    //     never = !never
    //     quotedelaytip_never_input.checked = never
    //     setNever(never)
    //   }    
    // }
}
exports.openModal = openModal;
function setNever(nevervalue) {
    if (nevervalue) {
        cookie_1["default"].set('quotedelaytip_never', '1', 365, '.eastmoney.com');
    }
    else {
        cookie_1["default"].del('quotedelaytip_never', '.eastmoney.com');
    }
}
function Close() {
    // if(!quotedelaytip_is_option){
    var body = document.body;
    body.removeChild(div);
    // }
    // else{
    //   if(window['quotedelaytip_option_goto'] != undefined){
    //     self.location.href = window['quotedelaytip_option_goto']
    //   }
    //   else if(is_mobile){
    //     self.location.href = 'https://wap.eastmoney.com/quote/index.html'
    //   }
    //   else{
    //     self.location.href = 'https://quote.eastmoney.com/center'
    //   }
    // }
}
